import styled from 'styled-components';
import DefaultDayPickerInput from 'react-day-picker/DayPickerInput';
import addAlpha from 'utils/addAlpha';
import { CalendarIcon as DefaultCalendarIcon } from '../Detail/ExtraInfo/styles';

export const Container = styled.div`
  width: auto;
  display: flex;
  align-items: center;
`;

export const DayPickerStyles = styled.div`
  &&& {
    .DayPicker,
    .DayPicker-wrapper {
      color: ${({ theme }) => theme.colors.navyGreen};
      :focus {
        outline: none;
      }
    }

    .DayPicker-wrapper {
      padding: 0.875rem;
    }

    .DayPicker-Weekday {
      color: ${({ theme }) => theme.colors.greenExtraDark};
    }

    .DayPicker-Body {
      background-color: ${({ theme }) => theme.colors.white};
      color: ${({ theme }) => theme.colors.navyGreen};
    }

    .DayPicker-Day--today {
      color: ${({ theme }) => theme.colors.greenExtraDark};
    }

    .DayPicker-Day:not(.DayPicker-Day--start):not(.DayPicker-Day--end):not(
        .DayPicker-Day--outside
      ):not(.DayPicker-Day--selected) {
      :hover {
        background-color: ${({ theme }) => theme.colors.greenExtraLight};
      }
    }

    .DayPicker-Day--selected:not(.DayPicker-Day--start):not(
        .DayPicker-Day--end
      ):not(.DayPicker-Day--outside) {
      background-color: ${({ theme }) => theme.colors.greenExtraLight};
      color: ${({ theme }) => theme.colors.navyGreen};
    }

    .DayPicker-Day--selected {
      border-radius: 0;
    }

    .DayPicker-Day--end:not(.DayPicker-Day--outside),
    .DayPicker-Day--start:not(.DayPicker-Day--outside) {
      background-color: ${({ theme }) => theme.colors.greenMedium};
      color: ${({ theme }) => theme.colors.navyGreen};
      font-weight: 600;
    }

    .DayPicker-Day--start {
      border-top-left-radius: 50%;
      border-bottom-left-radius: 50%;
    }

    .DayPicker-Day--end {
      border-top-right-radius: 50%;
      border-bottom-right-radius: 50%;
    }

    input {
      width: 9.75rem;
      height: 3.5rem;
      border-radius: 1rem;
      padding: 0.9063rem 1.5rem;
      background-color: ${({ theme }) => theme.colors.white};
      text-align: center;
      font-size: 1.1875rem;
      line-height: 1.6625rem;
      font-weight: 600;
      border: none;
      color: ${({ theme }) => theme.colors.navyGreen};
      :focus {
        outline: none;
      }
      :hover {
        cursor: pointer;
      }
    }
  }
`;

// @ts-ignore
export const DayPickerInput = styled(DefaultDayPickerInput)``;

export const Separation = styled.span`
  width: 0.5831rem;
  margin: 0.7081rem;
  border-bottom: 0.125rem solid
    ${({ theme }) => addAlpha(theme.colors.navyGreen, 0.6)};
`;

export const CalendarIcon = styled(DefaultCalendarIcon)`
  vertical-align: middle;
  margin-left: 10px;
`;
